/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Buffer } from 'buffer';

import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id, projectId: ZodTypes.Id });

export const GetProjectThumbnail = {
  id: 'project-thumbnail.get',
  tag: 'Project',
  summary: 'Get project thumbnail',
  description:
    'If no image or seed is set, the projects ID will be used to seed the image.\n' +
    'If no size is supplied, the standard size of the image will be used. (64px for generated images and the original size for uploaded images).',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/thumbnail`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'image/png': {
          schema: z.instanceof(Buffer).openapi({ format: 'binary' }),
        },
      },
    },
  },
} as const satisfies Endpoint;
